
import { defineComponent, reactive, ref } from 'vue';
import Alert from '@/components/ui-elements/Alert.vue';
import { Form } from '@/components/ui-elements';
import Input from '@/components/ui-elements/form/Input.vue';
import LoaderIcon from '@/components/ui-elements/icons/LoaderIcon.vue';
import useHttp from '@/hooks/useHttp';
import { useUserStore } from '@/store';
import { useRouter } from 'vue-router';

export default defineComponent({
	components: {
		Alert,
		Form,
		Input,
		LoaderIcon,
	},
	setup() {
		const userStore = useUserStore();
		const { push } = useRouter();
		const alert = reactive({
			display: false,
			message: '',
		});
		const totp = ref('');
		const disableSubmit = ref(false);
		const isValid = ref(false);

		const handleClick = async () => {
			disableSubmit.value = true;
			const { post } = useHttp();
			const { success, error } = await post({
				path: 'two-factor-challenge',
				params: {
					code: totp.value,
				},
			});

			if (!success) {
				alert.display = true;
				alert.message = error;
				disableSubmit.value = false;
			} else {
				await userStore.getToken();
				push({ name: 'home' });
			}
		};

		return { alert, disableSubmit, handleClick, isValid, totp };
	},
});
